import * as React from 'react';
import { DetailsLine } from './DetailsLine';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';

export interface DetailsCardProps {
    /**array of icon and text for each line in details section of TXP */
    lines: TxpDataRow[];
    txpStyle: TxpStyle;
    isEditableEntity?: boolean;
}

export default class Details extends React.Component<DetailsCardProps, {}> {
    render() {
        let { lines, txpStyle, isEditableEntity } = this.props;
        let detailsLines = lines.map((TxpDataRow, index) => {
            return (
                <DetailsLine
                    key={index}
                    detailsData={TxpDataRow}
                    txpStyle={txpStyle}
                    isFlightCardLine={false}
                    isEditableEntity={isEditableEntity}
                />
            );
        });

        return <>{detailsLines}</>;
    }
}
